const dropdownOutsideClick = (parentEl) => {
    window.addEventListener('click', e => {
        const dropdownEls = parentEl.querySelectorAll('.b-flag-select')
        Array.from(dropdownEls).forEach((dropdownEl) => {
          if (!dropdownEl.contains(e.target)) {
            const ulListEl = dropdownEl.querySelector(".b-flag-select__list");
            const spanValueEl = dropdownEl.querySelector(
              ".b-flag-select__value"
            );
            const inputEl = dropdownEl.querySelector(
              ".b-flag-select__search-field"
            );
            dropdownEl?.classList.remove("wuds-dropdown--active");
            toggleDropdown(true, ulListEl, dropdownEl);
            spanValueEl &&
              inputEl &&
              toggleInputLabelBank(true, spanValueEl, inputEl);
          }
        });
        const dropdownElsInput = parentEl.querySelectorAll(".wuds-dropdown:not(.b-flag-select)")
        Array.from(dropdownElsInput).forEach((dropdownEl) => {
             if (!dropdownEl.contains(e.target)) {
                const ulListEl = dropdownEl.querySelector(".b-flag-select__list");
                ulListEl?.classList.add('d-none')
                ulListEl?.classList.remove('d-block')
            }
        });
    })
}

const setDrodpownLabelInputValue = (li, inputEl, spanValueEl) => {
    const dataValue = li.getAttribute("data-value") || li.innerText;
    inputEl.setAttribute("value", dataValue);
    inputEl.value = dataValue;
    spanValueEl.innerHTML = dataValue;
}

const selectDefaultCountry = (inputEl, spanValueEl, dropdownEl, wudsDropdownEl) => {
    const AkCountry = getAkCountryRMO();
    if(inputEl.id.includes('country-dropdown')) {
        const lis = dropdownEl.querySelectorAll("li");
        Array.from(lis).forEach((li) => {
          if (li.getAttribute("data-slug")?.toUpperCase() === AkCountry?.toUpperCase()) {
            setDrodpownLabelInputValue(li, inputEl, spanValueEl);
          }
        });
    }
    if (wudsDropdownEl.id === "country-code-input-div") {
      const lisCountryCode = dropdownEl.querySelectorAll("li");
      Array.from(lisCountryCode).forEach((li) => {
        if (li.innerText === "United States (+1)") {
          setDrodpownLabelInputValue(li, inputEl, spanValueEl);
        }
      });
    }
}

const toggleDropdown = (closeDropdown, unorderedListBank, dropdownEl) => {
    if(closeDropdown){
        unorderedListBank?.classList.remove('d-block')
        unorderedListBank?.classList.add("d-none");
        // toggleClass(unorderedListBank, 'd-block', 'd-none')
        dropdownEl.classList.remove('wuds-dropdown--active')
        return;
    } 
    if (unorderedListBank.classList.contains('d-none')) {
        unorderedListBank.classList.add("d-block");
        unorderedListBank.classList.remove("d-none");
        // toggleClass(unorderedListBank, 'd-none', 'd-block')
        dropdownEl.classList.add('wuds-dropdown--active')
    } else {
      unorderedListBank.classList.remove("d-block");
      unorderedListBank.classList.add("d-none");
      // toggleClass(unorderedListBank, 'd-block', 'd-none')
      dropdownEl.classList.remove("wuds-dropdown--active");
    }
}

const addLiTounorderedList = (text, value, fragment) => {
            let li = document.createElement('li');
            li.className = 'wuds-dropdown__items b-flag-select__item pad-8-lt';
            li.setAttribute('data-text', text)
            li.setAttribute('data-value', value)
            li.innerText = text
            li.setAttribute('tabindex', '0')
            fragment.append(li)
        }

const toggleInputLabelBank = (labelDisplay, labelEl, inputEl) => {
    if(labelDisplay) {
        toggleClass(labelEl, 'd-none', 'd-block')
        inputEl.classList.add('d-none')
        inputEl.setAttribute('value', labelEl?.innerHTML)
    } else {
        toggleClass(labelEl, 'd-block', 'd-none')
        inputEl.classList.remove('d-none')
        inputEl.focus()
    }
}

const stateCountryDropdownLink = (e, li) => {
    if(e.target.getAttribute('data-type') === 'country') {
            stateFeature(
              li.parentElement.parentElement.querySelector("input"),
              (
                li.closest(".repeater-mo-individual") ||
                li.closest(".repeater-contact-info")
              ).querySelector('[id^="state-dropdown-ul"]')
            );
    }
}

const stateFeature = (countryInputEl, stateDropdownEL) => {
    const AkCountry = getAkCountryRMO();
    const countryVal = countryInputEl.getAttribute('data-slug') || AkCountry.toLowerCase() || 'us'
    const states = countryVal === 'us' ? USAStates : CanadaStates
    if(stateDropdownEL.getAttribute('data-country-selected') === countryVal) return;
    stateDropdownEL.innerHTML = ``
    stateDropdownEL.setAttribute('data-country-selected', countryVal)
    stateDropdownEL.parentElement.querySelector('.b-flag-select__search-field').value = ''
    stateDropdownEL.parentElement.querySelector('.b-flag-select__value').innerHTML = ''
    const fragment = document.createDocumentFragment();
    for(let stateCode in states) {
        addLiTounorderedList(states[stateCode], stateCode, fragment)
    }
    stateDropdownEL.append(fragment)
    const liElements = stateDropdownEL.querySelectorAll('li')
    dynamicLiCreation(liElements, stateDropdownEL, stateDropdownEL.parentElement, stateDropdownEL.parentElement.querySelector('.b-flag-select__value'), stateDropdownEL.parentElement.querySelector('.b-flag-select__search-field'))
}

const spanTextBasedOnDataValue = (target) => {
    return target.closest("#country-code-ul-dropdown") ? target.getAttribute('data-value') : target.innerHTML
}

const setFlagDropdown = (target) => {
    const flagEl = target?.closest("#country-code-list")?.querySelector(".wu-flag")
    if(flagEl) {
        const exisitngFlag = flagEl.getAttribute('data-flag')
        const targetFlagClassList = target.querySelector(".wu-flag")?.classList || ['us']
        const flag = Array.from(targetFlagClassList).find((x) => x.indexOf("wu-flag") === -1);
        flagEl.setAttribute("data-flag", flag);
        toggleClass(flagEl, exisitngFlag, flag)
    }
}

const dynamicLiCreation = (liElements, dropdownEl, wudsDropdownEl, spanValueEl, inputEl)=> {
    Array.from(liElements).forEach(li => {
                li.setAttribute('tabindex','0')
                li.addEventListener('keydown', (e) => {
                    if(e.keyCode === 13) {
                        li.click()
                        e.stopPropagation()
                        e.preventDefault()
                    }
                })
                li.addEventListener('click', (e) => {
                    const dataValue = spanTextBasedOnDataValue(li)
                    spanValueEl.innerText = dataValue
                    setFlagDropdown(li)
                    dropdownEl?.querySelector(".wu-input_flag-currency")?.removeAttribute('style')
                    hideValidationMessage(spanValueEl)
                    toggleDropdown(true, dropdownEl,wudsDropdownEl)
                    toggleInputLabelBank(true,spanValueEl, inputEl)
                    inputEl.setAttribute('value',dataValue)
                    inputEl.value = dataValue
                    inputEl.setAttribute('data-slug', e.target.getAttribute('data-slug'))
                    inputEl.setAttribute('data-value', dataValue)
                    const dataNextTab = wudsDropdownEl.getAttribute('data-next-tab')
                    if(dataNextTab) {
                        const nextTabEl = document.querySelector(dataNextTab)
                        nextTabEl?.focus()
                    } else {
                        wudsDropdownEl?.parentElement?.querySelector(".focus-ul-el")?.focus()
                    }
                    e.preventDefault()
                    e.stopPropagation()
                    //specific to country can be passed as seperate function
                    stateCountryDropdownLink(e, li)
                })
            })
}

const dropdownFeature = (parentEl, defaultCountryInputSelection=true) => {
    const dropdowns = parentEl.querySelectorAll('.b-flag-select__list')
    dropdownOutsideClick(parentEl)
    Array.from(dropdowns).forEach((dropdownEl) => {
        const wudsDropdownEl =  dropdownEl.closest('.wuds-dropdown')
        const spanValueEl = wudsDropdownEl.querySelector('.b-flag-select__value')
        const inputEl = wudsDropdownEl.querySelector('.b-flag-select__search-field')
        const liElements = dropdownEl.querySelectorAll('li.b-flag-select__item')
        const dropdownIconEl = wudsDropdownEl.querySelector(".wu-input_flag-currency")

        wudsDropdownEl.addEventListener('click', () => {
            toggleDropdown(false, dropdownEl, wudsDropdownEl)
            spanValueEl && inputEl && toggleInputLabelBank(false, spanValueEl, inputEl)
        })

        dropdownIconEl?.addEventListener('focusin', (e) => {
             toggleDropdown(false, dropdownEl, wudsDropdownEl)
            spanValueEl && inputEl && toggleInputLabelBank(false, spanValueEl, inputEl)
            e.stopPropagation()
        })

        wudsDropdownEl.addEventListener('keyup', (e) => {
            if(e.keyCode === 13) {     
                toggleDropdown(false, dropdownEl, wudsDropdownEl)
                spanValueEl && inputEl && toggleInputLabelBank(false, spanValueEl, inputEl)
            }
        })

        // !inputEl?.classList.contains("address-lookup") && inputEl?.addEventListener('change', (e) => {
        //     const liElements = dropdownEl.querySelectorAll('li.b-flag-select__item')
        //     const value = e.target.value
        //     const foundMatch = false
        //     Array.from(liElements).forEach(li => {
        //         if(li.innerText.toLowerCase() ===value?.toLowerCase()) {
        //             li.click()
        //             foundMatch = true
        //         }
        //         else {
        //             li.classList.remove('d-none')
        //         }
        //     })
        //     if(!foundMatch) e.target.value = ''
        //     e.stopPropagation()
        // })



        inputEl?.addEventListener('input', (e) => {
            const value =e.target.value
            const liElements = dropdownEl.querySelectorAll('li.b-flag-select__item')
            Array.from(liElements).forEach(li => {
                if(!value || li.innerText.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
                    li.classList.remove('d-none')
                }
                else {
                    li.classList.add('d-none')
                }
            })
            if(!e.target.value) spanValueEl.innerHTML = ''
        })
        
        dynamicLiCreation(liElements, dropdownEl, wudsDropdownEl, spanValueEl, inputEl)

        defaultCountryInputSelection && inputEl && spanValueEl && wudsDropdownEl && selectDefaultCountry(inputEl, spanValueEl, dropdownEl, wudsDropdownEl);
    })
}

